/* src/app/account/account-allocations/posting-account-container/posting-account-container.component.scss */
/*# sourceMappingURL=posting-account-container.component.css.map */
